import { Box } from 'aa-react-ui';
import { styledComponent } from 'lib/styled_component';
import { themeGet } from '@styled-system/theme-get';

interface IProps {
  disabled?: boolean;
}

const RowWrapper = styledComponent(Box)<IProps>`
    display: table-row;
    background-color: ${props => (props.disabled ? themeGet('colors.error.10') : 'white')};
`;

export default RowWrapper;
